import NonIncentivizedTooltip from 'components/ProductPage/RatingsAndReviews/ReviewsFilters/NonIncentivizedTooltip/NonIncentivizedTooltip';

export default NonIncentivizedTooltip;
